import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const BleedWrapper = styled.div`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  clip-path: url(#svgClip);
  z-index: 5;
`;

export const BleedSVG = styled.svg<{ bleed?: number; widestBleed?: number }>`
  height: ${props => (props.bleed ? `calc(100% - ${props.bleed}pt)` : '100%')};
  width: ${props => (props.bleed ? `calc(100% - ${props.bleed}pt)` : '100%')};
  position: absolute;
  top: ${props => (props.widestBleed ? `${props.widestBleed}pt` : 0)};
  left: ${props => (props.widestBleed ? `${props.widestBleed}pt` : 0)};
`;

export const BleedPath = styled.path<{
  strokeWidth: string;
  orientation: string;
  transformScale: number;
}>`
  stroke: rgba(0, 0, 0, 0.28);
  stroke-width: ${props => props.strokeWidth};
  fill: transparent;

  ${props =>
    props.orientation === 'LANDSCAPE' &&
    css`
      transform: rotate(90deg) scale(${props.transformScale});
      transform-box: fill-box;
      transform-origin: center;
    `}
`;

// export const SafetyLinePath = styled.path<{
//   bleed: number;
//   safetyLineTransformScale: number;
//   transformScale: number;
// }>`
//   fill: transparent;
//   x: ${props => props.bleed};
//   y: ${props => props.bleed};
//   stroke: black;
//   stroke-dasharray: 3, 3;
//   transform: scale(${props => props.safetyLineTransformScale});

//   ${props =>
//     props.orientation === 'LANDSCAPE' &&
//     css`
//       transform: rotate(90deg) scale(${props.transformScale});
//       transform-box: fill-box;
//       transform-origin: center;
//     `}
// `;
